import { Overlay } from '@radix-ui/react-dialog';
import { useEffect } from 'react';

import { cn } from '~/lib/cn';

import { OVERLAY_CLASSES } from './constants';

interface SlideOutOverlayProps {
  overlayRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
}

export function SlideOutOverlay({
  overlayRef,
  onClose: handleClose,
}: SlideOutOverlayProps) {
  // Animate the overlay into view when it mounts.
  useEffect(() => {
    overlayRef.current?.classList.add(OVERLAY_CLASSES.visible);
    overlayRef.current?.classList.remove(OVERLAY_CLASSES.hidden);
  }, [overlayRef]);

  return (
    <Overlay
      ref={overlayRef}
      className={cn(
        'size-full backdrop-blur transition-all duration-300 ease-out',
        OVERLAY_CLASSES.hidden,
      )}
      onClick={handleClose}
      role="presentation"
      aria-hidden="true"
    />
  );
}

SlideOutOverlay.displayName = 'SlideOutOverlay';
